import { useEffect, useState } from "react";
import { genericFetchData } from "../../../Services/Service";
import { getUserCode } from "../../../Storage/Datastore";
export const useCities = () => {
  // const [page, setPage] = useState(1);
  const [locationData, setLocationData] = useState("");
  const [countries, setcountries] = useState([]);
  const [states, setStates] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [platform, setPlatform] = useState(null);
  const [modal, setModal] = useState({ isOpen: false });
  const [cities, setCities] = useState("");

  const [search, setSearch] = useState({
    countryIds: [0],
    keyword: "",
    platformId: platform,
    pageNo: 1,
    pageSize: 10,
  });

  useEffect(() => {
    getFilteredData();
    getCountryList();
    getAllPlatform();
  }, [search]);

  useEffect(() => {
    setCities(locationData?.locations);
  }, [locationData]);

  const handleOpenPopUp = (data) => {
    setModal({ isOpen: true, data: data });
  };

  const handleOpenEditPopUp = (data) => {
    let combineData = { ...addNewCity, ...data };
    combineData.isUpdate = true;
    setModal({ isOpen: true, data: combineData });
  };

  const getSpecificCountries = async (countryId) => {
    const response = await genericFetchData(
      `/country/state/${countryId}`,
      "GET"
    );
    const status = response.status;
    const responseData = await response.json();
    if (responseData) {
      setStates(responseData?.states);
      return responseData?.states;
    }
    console.log("=======error", status);
  };

  const postApprovalData = async (approvalStatus) => {
    const response = await genericFetchData(
      `/locations/save`,
      "POST",
      approvalStatus
    );

    const status = response.status;

    if (status === 200) {
      getFilteredData();
    }
    console.log("=======error", status);
  };

  const addNewCity = {
    headText: "Add New Location",
    source: "",
    countryList: countries,
    statesList: states,
    handleSelected: getSpecificCountries,
    saveCity: postApprovalData,
    reason: "Add Reason",
    width: "620px",
    buttons: [
      { id: 1, buttonName: "Cancel" },
      { id: 2, buttonName: "Add" },
    ],
  };
  const deleteTableCell = (cellId) => {
    const cellItem = cities?.filter((item) => item.id !== cellId);
    setCities(cellItem);
    deleteSpecificData(cellId);
  };

  const handleDelete = (cellId) => {
    deleteBoxData.deleteId = cellId;
    setModal({ isOpen: true, data: deleteBoxData });
  };

  const deleteBoxData = {
    headText: "",
    source: "Are you sure want to delete?",
    type: "DELETE",
    deleteData: deleteTableCell,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  const tableHeader = [
    {
      id: 1,
      headText1: "City Name",
      headText2: "state",
      headText3: "country",
      headText4: "Approval",
      headText5: "",
    },
  ];

  const getFilteredData = async () => {
    const response = await genericFetchData(
      `/locations/filtered`,
      "POST",
      search
    );
    const status = response.status;
    const responseData = await response.json();
    if (responseData) {
      const mappedData = responseData?.locations.map((val) => {
        return {
          id: val?.id,
          cellItem1: val?.name,
          cellItem2: val?.state?.name,
          cellItem3: val?.country?.name,
          cellItem4: val?.approved,
          countryId: val?.country?.id,
          stateId: val?.state?.id,
        };
      });

      let res = { count: responseData?.count, locations: mappedData };
      setLocationData(res);
    }
    console.log("=======error", status);
  };

  const deleteSpecificData = async (cellId) => {
    const userCode = getUserCode();
    const response = await genericFetchData(
      `/locations/delete/${cellId}?userCode=${userCode}`,
      "DELETE"
    );
    const status = response.status;
    const responseData = await response.json();
    if (responseData) {
      getFilteredData();
    }
    console.log("=======error", status);
  };

  const getCountryList = async () => {
    const response = await genericFetchData(`/country/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (responseData) {
      setcountries(responseData?.countries);
    }
    console.log("=======error", status);
  };

  const getAllPlatform = async () => {
    const response = await genericFetchData(`/data/platform/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setPlatform(responseData.platforms);
      console.log(responseData.platforms, "+++h");
    } else {
      console.log("=======error");
    }
  };

  const handleCheckboxChange = (checked, index) => {
    const approvedData = { approved: checked, locationId: index };
    const approvedItem = locationData?.locations?.map((item) =>
      item.id === index ? { ...item, cellItem4: checked } : item
    );
    setCheckedItems(approvedItem);
    postApprovalData(approvedData);
  };

  const handleApprovePopup = (event, index) => {
    approveData.checked = event.target.checked;
    approveData.index = index;
    setModal({ isOpen: true, data: approveData });
  };

  const approveData = {
    headText: "",
    source: "Are you sure want to Approve?",
    type: "APPROVE",
    handleApprove: handleCheckboxChange,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  return {
    locationData,
    search,
    setSearch,
    countries,
    getApiFetchData: getFilteredData,
    postApprovalData,
    deleteSpecificData,
    getCountryList,
    getSpecificCountries,
    states,
    handleCheckboxChange,
    checkedItems,
    setCheckedItems,
    tableHeader,
    handleDelete,
    addNewCity,
    handleOpenEditPopUp,
    handleOpenPopUp,
    modal,
    setModal,
    cities,
    handleApprovePopup,
    platform,
  };
};
